import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const JobsiteContext = createContext(null);

export function JobsiteProvider({ children }) {
  const { user } = useAuth();
  const [sites, setSites] = useState([]);
  const [activeSiteId, setActiveSiteId] = useState(() => localStorage.getItem("ss_site") || null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/jobsites");
      setSites(data);
      if (data.length && !data.find((s) => s.id === activeSiteId)) {
        setActiveSiteId(data[0].id);
        localStorage.setItem("ss_site", data[0].id);
      }
    } finally {
      setLoading(false);
    }
  }, [user, activeSiteId]);

  useEffect(() => {
    if (user) refresh();
  }, [user, refresh]);

  const selectSite = (id) => {
    setActiveSiteId(id);
    localStorage.setItem("ss_site", id);
  };

  const activeSite = sites.find((s) => s.id === activeSiteId) || null;

  return (
    <JobsiteContext.Provider value={{ sites, activeSite, activeSiteId, selectSite, refresh, loading }}>
      {children}
    </JobsiteContext.Provider>
  );
}

export const useJobsite = () => useContext(JobsiteContext);
